import {
  BarcodeBrand,
  BarcodeSize,
  RoundingCondition,
} from 'pages/SettingsV2/settingsTypes';

export const TOGGLE_SWITCH_SIZE = 'md';

const BARCODE_IMG = 'https://pos2uapp.com/it/images/bracode';
const TEMPLATE_IMG = 'https://pos2uapp.com/it/images';

export const BARCODE_BRAND_OPTIONS: { value: BarcodeBrand; label: string }[] = [
  { value: 'see_dlabel', label: 'See-dlabel' },
  { value: 'click_label', label: 'Click Label' },
];

export const BARCODE_SIZE_OPTIONS: { value: BarcodeSize; label: string }[] = [
  { value: 'a7', label: 'A7 (22x38mm)' },
  { value: 'a8', label: 'A8 (27x38mm)' },
  { value: 'a10', label: 'A10 (27x50mm)' },
  { value: 'a11', label: 'A11 (30x55mm)' },
];

export const BARCODE_LAYOUTS: { value: 1 | 2 | 3 | 4 | 5; image: string }[] = [
  { value: 1, image: `${BARCODE_IMG}/type_1.png` },
  { value: 2, image: `${BARCODE_IMG}/type_2.png` },
  { value: 3, image: `${BARCODE_IMG}/type_3.png` },
  { value: 4, image: `${BARCODE_IMG}/type_4.png` },
  { value: 5, image: `${BARCODE_IMG}/type_5.png` },
];

export const TEMPLATE_OPTIONS: {
  value: 'new' | 'old';
  image: string;
  labelKey: string;
}[] = [
  {
    value: 'new',
    image: `${TEMPLATE_IMG}/template_doc_new.png?v=2`,
    labelKey: 'New Template',
  },
  {
    value: 'old',
    image: `${TEMPLATE_IMG}/template_doc_old.png?v=2`,
    labelKey: 'Old Template',
  },
];

export const ROUNDING_CONDITION_OPTIONS: {
  value: RoundingCondition;
  labelKey: string;
}[] = [
  { value: 0, labelKey: 'No Rounding' },
  { value: 1, labelKey: 'Round to Nearest' },
  { value: 2, labelKey: 'Round Up' },
  { value: 3, labelKey: 'Round Down' },
];

export const ROUNDING_INTERVAL_OPTIONS = [0.5, 1.0];

export const EXPIRY_YEAR_OPTIONS = [1, 2, 3, 4, 5];

export const SALE_CODE_TYPE_OPTIONS: { value: 0 | 1 | 2; labelKey: string }[] =
  [
    { value: 0, labelKey: 'Not Set' },
    { value: 1, labelKey: 'Auto Number' },
    { value: 2, labelKey: 'By Date' },
  ];

export const SALE_CODE_YEAR_OPTIONS: { value: 1 | 2; labelKey: string }[] = [
  { value: 1, labelKey: 'Buddhist Era (B.E.)' },
  { value: 2, labelKey: 'Christian Era (A.D.)' },
];

export const SALE_CODE_FORMAT_OPTIONS: {
  value: 'y' | 'ym' | 'ymd' | 'Y' | 'Ym' | 'Ymd';
  label: string;
}[] = [
  { value: 'y', label: 'YY' },
  { value: 'ym', label: 'YYMM' },
  { value: 'ymd', label: 'YYMMDD' },
  { value: 'Y', label: 'YYYY' },
  { value: 'Ym', label: 'YYYYMM' },
  { value: 'Ymd', label: 'YYYYMMDD' },
];

export const SALE_CODE_DIGIT_OPTIONS = [2, 3, 4, 5, 6];
